var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "px-5 pt-5" },
    [
      _c(
        "b-card",
        [
          _c("b-card-body", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", { staticClass: "text-primary mb-3" }, [_vm._v("Lote")])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Funcionario creador")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.batch.usuarioNombre) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Folio")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.batch.folio) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Número interno")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.batch.numeroInterno) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Estado")]),
                  _c(
                    "div",
                    { staticClass: "ml-3" },
                    [
                      _vm.batchesStates[_vm.batch.estado]
                        ? _c(
                            "vs-chip",
                            {
                              directives: [
                                {
                                  name: "tooltip",
                                  rawName: "v-tooltip",
                                  value:
                                    "" +
                                    _vm.batchesStates[_vm.batch.estado].label,
                                  expression:
                                    "`${batchesStates[batch.estado].label}`"
                                }
                              ],
                              attrs: {
                                color: _vm.batchesStates[_vm.batch.estado].color
                              }
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.batchesStates[_vm.batch.estado].label
                                  ) +
                                  " "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Ex Lote")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm.batch.esExLote == _vm.IS_EXISTING_BATCH
                      ? _c("span", [_vm._v(" Si ")])
                      : _vm._e(),
                    _vm.batch.esExLote == _vm.IS_NOT_EXISTING_BATCH
                      ? _c("span", [_vm._v(" No ")])
                      : _vm._e()
                  ])
                ])
              ]),
              _vm.batch.motivoDevolucion
                ? _c("div", { staticClass: "col-6 mt-3" }, [
                    _c("div", [
                      _c("strong", [_vm._v("Motivo devolución")]),
                      _c("div", { staticClass: "ml-3" }, [
                        _c("span", [
                          _vm._v(" " + _vm._s(_vm.batch.motivoDevolucion) + " ")
                        ])
                      ])
                    ])
                  ])
                : _vm._e(),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Aduana Loteadora")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.batch.loteadoraDescripcion) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Requiere VB")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm.batch.requiereVb == _vm.NO_APPROVAL_REQUIRED
                      ? _c("span", [_vm._v(" No ")])
                      : _vm._e(),
                    _vm.batch.requiereVb == _vm.YES_APPROVAL_REQUIRED
                      ? _c("span", [_vm._v(" Si ")])
                      : _vm._e()
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Fecha de emisión")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("dateFormat")(_vm.batch.fechaCreacion)) +
                        " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Monto mínimo")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" $" + _vm._s(_vm.batch.montoMinimo) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Clasificación de lote")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " + _vm._s(_vm.batch.clasificacionLoteDescripcion) + " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Tipo de medida")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.batch.tipoMedidaDescripcion) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Peso")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.batch.pesoLote) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Unidad de medida")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " + _vm._s(_vm.batch.unidadMedidaDescripcion) + " "
                    )
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c("b-card-body", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", { staticClass: "text-primary mb-3" }, [
                  _vm._v("Jurídica")
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Calidad jurídica")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.batch.calidadJuridicaNombre) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Fecha de presunción")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormat")(_vm.batch.fechaPresuncion)
                        ) +
                        " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Fecha de incautación")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm._f("dateFormat")(_vm.batch.fechaIncautacion)
                        ) +
                        " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Causa Art. Ord. 136")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.batch.causaArtOrd) + " ")
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _c(
        "b-card",
        [
          _c("b-card-body", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", { staticClass: "text-primary mb-3" }, [
                  _vm._v("Mercancía")
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Consignatorio")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(" " + _vm._s(_vm.batch.consignatorio) + " ")
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Fecha de loteo")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm._f("dateFormat")(_vm.batch.fechaLoteo)) +
                        " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Ubicación de mercancía")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " +
                        _vm._s(_vm.batch.ubicacionMercanciaDescripcion || "-") +
                        " "
                    )
                  ])
                ])
              ]),
              _c("div", { staticClass: "col-6 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Calidad de mercancía")]),
                  _c("div", { staticClass: "ml-3" }, [
                    _vm._v(
                      " " + _vm._s(_vm.batch.calidadMercanciaValor || "-") + " "
                    )
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _vm.batch.estado === _vm.batchesCodeSates.rescatado
        ? _c(
            "b-card",
            [
              _c("b-card-body", [
                _c("div", { staticClass: "row" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("h4", { staticClass: "text-primary mb-3" }, [
                      _vm._v("Rescate")
                    ])
                  ]),
                  _vm.batch.f09Numero
                    ? _c("div", { staticClass: "col-6 mt-3" }, [
                        _c("div", [
                          _c("strong", [_vm._v("F-09")]),
                          _c("div", { staticClass: "ml-3" }, [
                            _vm._v(" " + _vm._s(_vm.batch.f09Numero) + " ")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.batch.f09FechaPago
                    ? _c("div", { staticClass: "col-6 mt-3" }, [
                        _c("div", [
                          _c("strong", [_vm._v("Fecha de pago")]),
                          _c("div", { staticClass: "ml-3" }, [
                            _vm._v(" " + _vm._s(_vm.batch.f09FechaPago) + " ")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.batch.f09MontoPago
                    ? _c("div", { staticClass: "col-6 mt-3" }, [
                        _c("div", [
                          _c("strong", [_vm._v("Monto cancelado")]),
                          _c("div", { staticClass: "ml-3" }, [
                            _vm._v(" " + _vm._s(_vm.batch.f09MontoPago) + " ")
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.batch.rescateFechaResolucion
                    ? _c("div", { staticClass: "col-6 mt-3" }, [
                        _c("div", [
                          _c("strong", [_vm._v("Fecha Resolución")]),
                          _c("div", { staticClass: "ml-3" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.batch.rescateFechaResolucion) +
                                " "
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _vm.batch.rescateNumeroResolucion
                    ? _c("div", { staticClass: "col-6 mt-3" }, [
                        _c("div", [
                          _c("strong", [_vm._v("Número resolución")]),
                          _c("div", { staticClass: "ml-3" }, [
                            _vm._v(
                              " " +
                                _vm._s(_vm.batch.rescateNumeroResolucion) +
                                " "
                            )
                          ])
                        ])
                      ])
                    : _vm._e(),
                  _c("div", { staticClass: "col-12 mt-3" }, [
                    _c("div", [
                      _c("strong", [_vm._v("Motivo rescate")]),
                      _c("div", { staticClass: "ml-3 mr-4 text-justify" }, [
                        _vm._v(
                          " " + _vm._s(_vm.batch.rescateMotivo || "-") + " "
                        )
                      ])
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _c(
        "b-card",
        [
          _c("b-card-body", [
            _c("div", { staticClass: "row" }, [
              _c("div", { staticClass: "col-12" }, [
                _c("h4", { staticClass: "text-primary mb-3" }, [
                  _vm._v("Descripción y adicionales")
                ])
              ]),
              _c("div", { staticClass: "col-12 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Descripción del lote")]),
                  _c(
                    "div",
                    { staticClass: "ml-3 container-description text-justify" },
                    [_vm._v(" " + _vm._s(_vm.batch.descripcionLote) + " ")]
                  )
                ])
              ]),
              _c("div", { staticClass: "col-12 mt-3" }, [
                _c("div", [
                  _c("strong", [_vm._v("Datos adicionales internos")]),
                  _c("div", { staticClass: "ml-3 mr-4 text-justify" }, [
                    _vm._v(" " + _vm._s(_vm.batch.descripcionLoteFactura) + " ")
                  ])
                ])
              ])
            ])
          ])
        ],
        1
      ),
      _vm.batchImages.length
        ? _c("div", { staticClass: "row mb-5 px-5" }, [
            _c("div", { staticClass: "col-12 mt-3 mb-3" }, [
              _c("h5", { staticClass: "text-primary" }, [
                _vm._v("Imágenes del lote")
              ]),
              _c(
                "div",
                { staticClass: "row" },
                _vm._l(_vm.batchImages, function(image) {
                  return _c("img", {
                    key: image.imagenId,
                    staticClass: "col-4 mt-2 mr-2 cursor-pointer img-batch",
                    attrs: { src: image.urlImagen, alt: "logo" }
                  })
                }),
                0
              )
            ])
          ])
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }